module.exports = "<h1>Edit user</h1>\n\n<div [hidden]=\"!error\" class=\"alert alert-danger\" role=\"alert\">\n  <strong>Error:</strong> {{error}}\n</div>\n\n<div [hidden]=\"!success\" class=\"alert alert-success\" role=\"alert\">\n  <strong>Success!</strong> Update complete. <a href=\"#/users\">View Users</a>\n</div>\n\n<user-form *ngIf=\"model\" [model]=\"model\" [loading]=\"loading\" (onSubmit)=\"editUser($event)\"></user-form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/edit.user.component.html
// module id = 898
// module chunks = 1